var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.94,
    height: 35.94,
    viewBox: "0 0 35.94 35.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g522",
    transform: "translate(-0.145 682.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g524",
    transform: "translate(25.529 -675.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M0-185.71V-196",
    transform: "translate(0 196)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g528",
    transform: "translate(0.895 -681.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34625",
    "data-name": "Group 34625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g536",
    transform: "translate(0 18.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M0,0V11.27a1.4,1.4,0,0,0,1.4,1.4H21.245",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M-333.414,0h-17.074a1.4,1.4,0,0,0-1.4,1.4V20.489",
    transform: "translate(351.888)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g544",
    transform: "translate(18.474 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M-111.173-111.173l-6.16-6.16v4.856a1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(117.333 117.333)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g548",
    transform: "translate(4.271 19.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M-256.339,0h-14.2",
    transform: "translate(270.542)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g552",
    transform: "translate(4.271 23.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M-256.339,0h-14.2",
    transform: "translate(270.542)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g556",
    transform: "translate(4.271 27.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M-151.6,0H-160",
    transform: "translate(160)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g560",
    transform: "translate(18.76 15.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M-141.488,0l7.84,2.448V8.995a9.658,9.658,0,0,1-7.84,9.485h0a9.658,9.658,0,0,1-7.84-9.485V2.448L-141.487,0",
    transform: "translate(149.328)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g568",
    transform: "translate(24.36 23.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M0-22.639l1.613,1.613L4.48-23.893",
    transform: "translate(0 23.893)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g572",
    transform: "translate(8.191 6.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M-161.706-50.533h-2.8v-2.8h-3.36v2.8h-2.8v3.36h2.8v2.8h3.36v-2.8h2.8Z",
    transform: "translate(170.666 53.333)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g576",
    transform: "translate(0 15.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M0,0H0",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.808a681bf0ca20de5ca4288150586645.svg";
export { ForwardRef as ReactComponent };